module.exports = __webpack_public_path__ + "media/images/views/job/cdd-2-81af1a8795b23f741f9525e126f1592d.png";